import { CheckoutPricing } from '../../hooks/checkouts/useCheckoutPricing';
import FormSmallModal from '../global/FormSmallModal';
import AddServiceOrItemModal from './AddServiceOrItemModal';
import TransferAppointmentDepositModal from '../appointments/TransferAppointmentDepositModal';
import TipModal from './TipModal';

/** The dialogs the cart opens, shared by both checkout layouts. */
export default function CheckoutPricingModals({
  pricing: { modals },
}: {
  pricing: CheckoutPricing;
}) {
  return (
    <>
      <AddServiceOrItemModal
        open={!!modals.addItems}
        initialTab={modals.addItems?.tab}
        onClose={modals.closeAddItems}
        services={modals.services}
        appointment={modals.appointment}
      />
      <FormSmallModal
        open={!!modals.form}
        onClose={modals.closeForm}
        form={modals.form}
      />
      <TipModal
        open={modals.tip.open}
        onClose={modals.tip.close}
        base={modals.tip.base}
        amount={modals.tip.amount}
        percent={modals.tip.percent}
        providers={modals.tip.providers}
        onApply={modals.tip.apply}
      />
      {!!modals.appointment && modals.isDepositTransferModalOpen && (
        <TransferAppointmentDepositModal
          isOpen
          onClose={modals.closeDepositTransfer}
          appointment={modals.appointment}
          onRefresh={modals.refreshAppointment}
        />
      )}
    </>
  );
}
